import { Component, type ReactNode } from "react";
import { ErrorFallback } from "@/shared/components";

interface Props {
  children: ReactNode;
  fallback?: (error: Error | null) => ReactNode;
  resetKey?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false, error: null });
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ? this.props.fallback(this.state.error) : <ErrorFallback error={this.state.error} />;
    }
    return this.props.children;
  }
}
